module.exports = __webpack_public_path__ + "img/updates.b6500910.png";